/**
 * markUntranslated (P127 / brand P2.11).
 *
 * Builds an untranslated catalogue scaffold from the English one:
 * recursively clones the catalogue, wrapping every leaf STRING in
 * `‹ ›` guillemets so the value is visibly "pending translation" while
 * staying readable + RTL-testable. Interpolation placeholders
 * (`{{count}}`), plural `_one`/`_other` keys, and the whole key shape
 * are preserved untouched.
 *
 * Why generated, not hand-written: it guarantees the Arabic bundle has
 * EVERY key the English one has (parity by construction -- the return
 * type is identical), and it stays in sync automatically as `en.ts`
 * grows. A translator later replaces this with a real `ar` catalogue;
 * until then the mechanism (language switch + `dir="rtl"`) ships without
 * fabricating Arabic strings.
 */

const OPEN = "‹"; // ‹
const CLOSE = "›"; // ›

export function markUntranslated<T>(node: T): T {
  if (typeof node === "string") {
    return `${OPEN}${node}${CLOSE}` as unknown as T;
  }
  if (node !== null && typeof node === "object") {
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(node)) {
      out[key] = markUntranslated(value);
    }
    return out as unknown as T;
  }
  // Non-string primitives (none today) pass through unchanged.
  return node;
}
